module.exports = __webpack_public_path__ + "img/2024-04.a2038d8b.jpg";